import { render } from "./FieldNameInline.vue?vue&type=template&id=2638f7f6&scoped=true"
import script from "./FieldNameInline.vue?vue&type=script&lang=js"
export * from "./FieldNameInline.vue?vue&type=script&lang=js"

import "./FieldNameInline.vue?vue&type=style&index=0&id=2638f7f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2638f7f6"]])

export default __exports__